import OrderComp from "../../components/delivery/OrderComp";

function Order() {

  return (
    <OrderComp/>
  );
}

export default Order;